module.exports = __webpack_public_path__ + "static/media/ic_conduite_chariot.fe39c31e.svg";